import {
  DashboardRounded, Groups2Rounded, TrackChangesRounded, PersonAddAlt1Rounded,
  CloudDoneRounded, AccountBalanceWalletRounded, InsightsRounded, SchoolRounded,
  GavelRounded, AccountTreeRounded, ForumRounded, NotificationsRounded,
  PersonRounded, HelpOutlineRounded, SettingsRounded
} from "@mui/icons-material";

export const fdcNavigation = [
  { group: "Overview", items: [
    { label: "Dashboard", page: "dashboard", icon: DashboardRounded },
    { label: "Activity", page: "activity", icon: InsightsRounded },
  ]},
  { group: "Business Development", items: [
    { label: "Clients", page: "clients", icon: Groups2Rounded },
    { label: "Targets", page: "targets", icon: TrackChangesRounded },
    { label: "Onboarding", page: "onboarding", icon: PersonAddAlt1Rounded },
    { label: "UniCloud", page: "unicloud", icon: CloudDoneRounded },
  ]},
  { group: "Performance", items: [
    { label: "Earnings & Wallet", page: "wallet", icon: AccountBalanceWalletRounded },
    { label: "Performance", page: "performance", icon: InsightsRounded },
    { label: "Training", page: "training", icon: SchoolRounded },
    { label: "Queries & Evaluations", page: "queries", icon: GavelRounded },
  ]},
  { group: "Workspace", items: [
    { label: "Administration", page: "administration", icon: AccountTreeRounded },
    { label: "Messages", page: "messages", icon: ForumRounded },
    { label: "Notifications", page: "notifications", icon: NotificationsRounded },
    { label: "My Profile", page: "profile", icon: PersonRounded },
    { label: "Settings & Security", page: "settings", icon: SettingsRounded },
    { label: "Help & Support", page: "support", icon: HelpOutlineRounded },
  ]},
];

export const pageTitles = Object.fromEntries(
  fdcNavigation.flatMap(group => group.items.map(item => [item.page, item.label]))
);
